import { getLanguage } from '../../components/languageSelect/helpers/functions';

export const createHeaders = () => {
  const authUser = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Accept-Language': getLanguage(),
    // webVersion: environment.versions.app,
  };
  if (authUser) {
    const a_token = JSON.parse(authUser);
    return {
      ...headers,
      Authorization: 'Bearer ' + a_token.token,
      // authServiceValidated: 'true',
    };
  } else {
    return headers;
  }
};

export const createTokenHeader = () => {
  const authUser = localStorage.getItem('authToken');
  const headers = {
    'content-type': 'multipart/form-data',
    'Access-Control-Allow-Origin': '*',
    'Accept-Language': getLanguage(),
    // webVersion: environment.versions.app,
  };
  if (authUser) {
    const a_token = JSON.parse(authUser);
    return {
      ...headers,
      Authorization: 'Bearer ' + a_token.token,
      // authServiceValidated: 'true',
    };
  } else {
    return headers;
  }
};
